import { Injectable, OnInit } from '@angular/core';
import { ListMetadata } from 'app/models/list-metadata.model';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Observable } from 'rxjs';
import { HttpClientService } from '../httpClient/httpclient.service';

@Injectable()
export class UserStoreDivisionService {

  baseUrl = 'koncentro-common'
  
  constructor(
    private http: HttpClientService
  ) { }

  /**
 * Restituisce la lista delle Campagne
 */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/auth/getUserStoreDivision?' + params.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/store/user-store-division.service.ts